import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Button, Typography, Popover, MenuList, MenuItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { generateFirstName } from "utils/helpers";

import Routes from "config/routes";
const useStyles = makeStyles((theme) => ({
  iframeNavActions: {
    display: "flex",
    gap: theme.spacing(1),
  },
}));

const IframeNavActions = ({ authUser, onSignOut, onFindBooking, onSignUp, onSignIn }) => {
  const classes = useStyles();
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const menuOpen = Boolean(menuAnchorEl);

  const handleMenuOpen = (e) => {
    setMenuAnchorEl(e.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const userFirstName = generateFirstName(authUser?.displayName) || "My Account";

  return (
    <div className={classes.iframeNavActions}>
      {authUser ? (
        <>
          <Button variant="text" onClick={onSignOut}>
            <Typography variant="text" className={classes.initials}>
              Sign out
            </Typography>
          </Button>
          <Button variant="contained" color="primary" onClick={handleMenuOpen}>
            <Typography variant="primary" className={classes.initials}>
              {userFirstName}
            </Typography>
          </Button>
          <Popover
            open={menuOpen}
            anchorEl={menuAnchorEl}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}>
            <MenuList className={classes.menu}>
              <MenuItem component={Link} to={Routes.ACCOUNT}>
                My account
              </MenuItem>
            </MenuList>
          </Popover>
        </>
      ) : (
        <>
          <Button variant="outlined" onClick={onSignUp}>
            Join Now
          </Button>
          <Button variant="contained" color="primary" onClick={onSignIn}>
            Sign In
          </Button>
        </>
      )}
    </div>
  );
};
IframeNavActions.propTypes = {
  authUser: PropTypes.object,
  onSignOut: PropTypes.func.isRequired,
  onFindBooking: PropTypes.func.isRequired,
  onSignUp: PropTypes.func.isRequired,
  onSignIn: PropTypes.func.isRequired,
};

export default IframeNavActions;
